export const sidebarItems = [
  // {
  //   id: 1,
  //   label: "Courses",
  //   constant: "course",
  //   icon: "ri-book-open-line",   
  //   path: "/course",
  //   badgeColor: "success",
  //   badgeName: "",
  //   moduleaccess: true,
  //   viewonly: false,
  //   iseditaccess: true
  // },
];
